import { NAME } from './constants';
import { router } from './router';
import { apiProvider } from './api';

export const PartReturnRequest = {
	name: NAME,
	apiProvider,
	router,
};
